import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { supportActions } from '../actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import ReactTable from 'srcReact/components/common2/ReactTable'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useTranslation } from 'react-i18next'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { isMobileScreen } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'

function Tickets(props) {
  const dispatch = useDispatch()
  const orgId = getCurrentOrgId()
  const { t } = useTranslation()

  const {
    support: {
      tickets: { list, loading, stats }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    dispatch(supportActions.getTickets(orgId, 0))
  }, [])

  const updateTicket = (row) => {}

  const handleCurrentPage = (page) => {
    const offset = (page - 1) * appConstantSettings.PAGINATION_QTY
    dispatch(supportActions.getTickets(orgId, offset))
  }

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        id: 'id',
        className: styles.columnData,
        accessor: (row, idx) => <AnchorLink path={`/0/support/tickets/${row.id}`}>{row.id}</AnchorLink>
      },
      {
        Header: t('formlabel.subject'),
        id: 'subject',
        className: styles.columnData,
        accessor: (row, idx) => <AnchorLink path={`/0/support/tickets/${row.id}`}>{row.subject}</AnchorLink>
      },
      {
        Header: t('contact.ticket.status'),
        id: 'status',
        className: styles.columnData,
        accessor: (row, idx) => <AnchorLink path={`/0/support/tickets/${row.id}`}>{row.statuses[0].name}</AnchorLink>
      }
    ],
    []
  )
  return (
    <PageContainer pageTitle={t('contact.titleAuth')} withHeader={true} withFooter={false}>
      <div className={styles.ticketsWrapper}>
        <h1 className={styles.title}>{t('contact.ticket.ticketList')}</h1>
        <AnchorLink className={styles.createNew} path='/0/support'>
          {isMobileScreen() ? <Icon size='large24' name='add' /> : t('contact.ticket.createTicket')}
        </AnchorLink>
        {list?.length > 0 && (
          <ReactTable
            columns={columns}
            data={list}
            loading={loading}
            className={styles.tableClassName}
            handleCurrentPage={handleCurrentPage}
            pagination={{ total: stats?.total, offset: stats?.nextOffset }}
            pageSize={appConstantSettings.PAGINATION_QUANTITY}
          />
        )}
      </div>
    </PageContainer>
  )
}

export default Tickets
